import { render, staticRenderFns } from "./NlpLogo.vue?vue&type=template&id=3503c05c"
import script from "./NlpLogo.vue?vue&type=script&lang=js"
export * from "./NlpLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports